import { useQuery } from '@tanstack/react-query'

import { getCustomerAddressById } from '@flecto/api/saas'
import { type ParameterID } from '@flecto/types'
import { isValidParameterID } from '@flecto/utils'

type QueryPayload = {
  customerId?: ParameterID
  addressId?: ParameterID
}

export function useQueryGetCustomerAddressById({
  customerId,
  addressId,
}: QueryPayload) {
  return useQuery({
    queryKey: [
      'QueryGetCustomerAddressById',
      Number(customerId),
      Number(addressId),
    ],
    queryFn: async () =>
      await getCustomerAddressById(customerId ?? '', addressId ?? ''),
    refetchOnWindowFocus: false,
    enabled: isValidParameterID(customerId) && isValidParameterID(addressId),
  })
}
